<script>
    import Vue from 'vue';
    const Event = new Vue({}); // message bus
    export default { Event };
</script>


// WEBPACK FOOTER //
// event.vue?158799cc